import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bef81972"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "err__title" }, "Component Error", -1))
const _hoisted_3 = { class: "err__msg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.componentError != '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, "Message: " + _toDisplayString(_ctx.componentError), 1)
        ]))
      : (_ctx.renderData != null)
        ? _renderSlot(_ctx.$slots, "default", {
            key: 1,
            args: _ctx.renderData.args,
            disabled: _ctx.renderData.disabled
          }, undefined, true)
        : _createCommentVNode("", true)
  ]))
}